import { getField, updateField } from "vuex-map-fields";
import approvalInfo from "./approvalInfo";
import personalInfo from "./personalInfo";

const getDefaultState = () => {
  return {
    approvalLineInfo: {
      corpBzwkCd: "", //결재업무코드
      aprvalSngleYn: "", //결재단계구분
      list: [], //결재선
      aprvalMemoAplyYn: "", //결재메모적용여부
      aprvalUseYn: "", //결재선사용여부
    },
    regiWwwBnkgLginIdList: [],
  };
};

const admin = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    actAllStateReset({ commit }) {
      commit("resetState");
      commit("approvalInfo/resetState");
      commit("personalInfo/resetState");
    },
  },
  modules: {
    approvalInfo,
    personalInfo,
  },
};

export default admin;
